<script setup lang="ts"></script>
<template>
  <div class="flex flex-col justify-start items-start gap-3">
    <div class="bg-gray-300 dark:bg-gray-700 rounded-md h-5 w-1/4 animate-pulse"></div>
    <div class="bg-gray-300 dark:bg-gray-700 rounded-md h-10 w-full animate-pulse"></div>
  </div>
</template>
